/** Money is stored as whole cents. These convert to/from the dollar-string a
 * form input shows and a display string. */

/** Cents → the value for a dollars text input ('' when unpriced). */
export function centsToInput(cents: number | null): string {
  return cents == null ? '' : String(cents / 100)
}

/**
 * A dollar amount as typed: digits, with commas only between groups of three, a
 * decimal point, and a leading "$" allowed. Anything else isn't an amount: it is
 * refused, never read as far as it makes sense ("12,500" was once read as 12).
 */
const DOLLARS = /^(?:\d{1,3}(?:,\d{3})+|\d+)?(?:\.\d+)?$/

/**
 * A dollars text input → whole cents: "$12,500.50" is 1,250,050. Null when blank
 * or not an amount ("12,5", "12500abc", "-5"), which every caller treats as
 * "enter it in dollars". Extra decimal places round to the cent.
 */
export function inputToCents(value: string): number | null {
  const amount = value.trim().replace(/^\$\s*/, '')
  if (amount === '' || amount === '.' || !DOLLARS.test(amount)) return null
  return Math.round(Number.parseFloat(amount.replaceAll(',', '')) * 100)
}

/** {@link inputToCents}, telling blank (null) apart from not an amount (undefined). */
export function dollarsToCents(value: string): number | null | undefined {
  if (value.trim() === '') return null
  return inputToCents(value) ?? undefined
}

/** Cents → a display string like "$12.50". */
export function formatPrice(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`
}
